import { dataTableSlotRecipe } from '@kintsugi/ui/recipes';

/**
 * Recipe-only DataTable styling for admin. Chakra `Table.Root` resolves the
 * `table` theme key, so we mount KDS `dataTableSlotRecipe` under that name.
 * Local DataTable / table JSX stays; we do not adopt KDS DataTable wholesale.
 *
 * Keep the full KDS root outline for bare `Table.Root` call sites. Wrappers
 * (`DataTable`, `TableContainer`) suppress that outline locally so their own
 * chrome (incl. pagination) is the single frame. No-op `outline` / `line`
 * variants for existing call sites.
 */
export const tableSlotRecipe = {
  ...dataTableSlotRecipe,
  variants: {
    ...dataTableSlotRecipe.variants,
    variant: {
      outline: {},
      line: {},
    },
  },
};

/** Applied on wrapped tables so the wrapper border is the only outer frame. */
export const suppressTableRootOutline = {
  borderWidth: '0',
  borderRadius: '0',
  borderStyle: 'none',
} as const;
